export enum eTypeAction{
    Creación = 1,
    Modificación = 2,
    Eliminación = 3
}